const initialState = {
    "paso": 'formm',
    "pasoAnt": "",
    "nuevoPass": "",
    "pregunta1": "",
    "pregunta2": "",
    "respuesta1": "",
    "respuesta2": "",
    "uid": "",
    "estatus": "",
}

export function recuperarRdc(state = initialState, action) {
    
    switch (action.type) {
        case "RECUPERAR_SET_PASO": 
            return {...state,
                "pasoAnt": state.paso,
                "paso": action.paso
            };
        case "RECUPERAR_RESET_PASO": 
            return {...state,
                "paso": 'form'
            };
        case "RECUPERAR_SET_datos":
            return {...state,
                "pregunta1": action.pregunta1,
                "pregunta2": action.pregunta2,
                "respuesta1": action.respuesta1,
                "respuesta2": action.respuesta2,
                "nuevoPass": action.nuevoPass
            }
        case "RECUPERAR_SET_UID":
            return {...state,
                "uid": action.uid
            }
        case "RECUPERAR_SET_ESTATUS":
            return {...state,
                "estatus": action.estatus
            }
        case "RECUPERAR_SET_PASOANT":
            return {...state,
                "pasoAnt": action.pasoAnt
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/recuperar-contrasenia/reducer.js